import React from 'react'

export const Required = () => <span className="text-danger font-weight-bold">*</span>;
